import { Translate } from '@components'

import { Button, ButtonsGroup, Space, Text } from '@billy/design-system'
import React, { ReactElement } from 'react'

import * as Styled from './styles'

interface VouchersActionsProps {
  isEditMode?: boolean
  onDelete: () => void
  onEditModeChange: () => void
  selectedRows: number
  totalRows: number
}

export const VouchersActions = ({
  isEditMode,
  onDelete,
  onEditModeChange,
  selectedRows,
  totalRows,
}: VouchersActionsProps): ReactElement => (
  <Styled.VouchersActionsWrapper>
    {isEditMode ? (
      <>
        <Text>
          <Translate count={selectedRows} value="voucher.inbox.vouchers_selected" />
        </Text>
        <Space size="s12" horizontal />
        <ButtonsGroup>
          <Button color="danger" disabled={!selectedRows} onClick={onDelete} size="sm">
            <Translate value="delete" />
          </Button>
          <Button onClick={onEditModeChange} size="sm">
            <Translate value="done" />
          </Button>
        </ButtonsGroup>
      </>
    ) : (
      <>
        <Text>
          <Translate count={totalRows} value="voucher.inbox.vouchers_total" />
        </Text>
        <Space size="s12" horizontal />
        <Button variant="outlined" onClick={onEditModeChange} size="sm">
          <Translate value="edit" />
        </Button>
      </>
    )}
  </Styled.VouchersActionsWrapper>
)
